import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import AgrupacionArticulosForm from '../../components/agrupaciones-articulos/AgrupacionArticulosForm';
import {
  useAgrupacionArticulosStore,
  type ActualizarAgrupacionArticulos
} from '../../stores/agrupaciones-articulos/agrupaciones-articulos.store';

const EditarAgrupacionArticulos = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const navigate = useNavigate();
  const {
    current: agrupacion,
    actualizar,
    cargarPorId,
    eliminar
  } = useAgrupacionArticulosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarAgrupacionArticulos) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await eliminar(id);
    navigate('/grupos-agrupaciones-articulos/agrupaciones');
  };

  return (
    <AgrupacionArticulosForm agrupacion={agrupacion} onSave={handleSave} onDelete={handleDelete} />
  );
};

export default EditarAgrupacionArticulos;
